import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import "./PropField.scss";
export const PropField = function PropField({ title, children }) {
    return _jsxs("div", { className: "canva-props-panel-prop-field-root", children: [_jsx("span", { children: title }), children] });
};
